import React, { createContext } from 'react';

/**
 * Source + Namespace
 * What integrations we should list
 * Template For Sources
 * - Filter
 * - Mapping
 * MappingFields
 * Integration Name
 */

export type IntegrationContext = {
  sourceFilter: { source: string; namespace?: string }[];
  selectedSource?: {
    source: string;
    namespace: string;
  };
  template: {
    [sourceNamespace: string]: {
      filter: Record<string, string>;
      mapping: Record<string, string>;
    };
  };
  mappingFields: string[];
  integrationName: string;
  formEnabled: boolean;
  setFormEnabled: React.Dispatch<React.SetStateAction<boolean>>;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntegrationContext = createContext<IntegrationContext | null>(null);
